import React from "react";
import { MdSmartToy } from "react-icons/md";

const AIThinkingLoader = () => {
  return (
    <div className="mt-6 rounded-xl border border-primary-cyan/20 overflow-hidden" style={{ backgroundColor: "#10182b" }}>
      <div className="flex flex-col items-center justify-center py-16">
        <div className="relative">
          <div className="w-20 h-20 rounded-full bg-primary-cyan/20 flex items-center justify-center animate-float">
            <MdSmartToy className="text-primary-cyan text-4xl" />
          </div>
          <div className="absolute -top-2 -right-2 flex gap-1.5 bg-[#10182b] rounded-full px-1.5 py-1">
            <span className="w-2 h-2 bg-primary-cyan rounded-full animate-bounce-delay-1"></span>
            <span className="w-2 h-2 bg-primary-cyan rounded-full animate-bounce-delay-2"></span>
            <span className="w-2 h-2 bg-primary-cyan rounded-full animate-bounce-delay-3"></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIThinkingLoader;